import React from 'react';

interface ChipProps {
  as?: 'span' | 'button';
  selected?: boolean;
  onToggle?: () => void;
  className?: string;
  children: React.ReactNode;
}

const BASE =
  'inline-flex items-center gap-1.5 px-3 py-1.5 border rounded-full text-xs font-semibold';

const Chip: React.FC<ChipProps> = ({
  as = 'span',
  selected = false,
  onToggle,
  className = '',
  children,
}) => {
  const stateClasses = selected
    ? 'border-we-ink bg-we-ink text-we-bg'
    : 'border-we-ink/25 bg-we-surface';

  if (as === 'button') {
    const buttonClasses = selected
      ? 'font-we-body cursor-pointer transition-colors'
      : 'font-we-body cursor-pointer transition-colors text-we-ink';
    const cls = `${BASE} ${stateClasses} ${buttonClasses} ${className}`
      .replace(/\s+/g, ' ')
      .trim();
    return (
      <button type="button" aria-pressed={selected} onClick={onToggle} className={cls}>
        {children}
      </button>
    );
  }

  const cls = `${BASE} ${stateClasses} ${className}`.replace(/\s+/g, ' ').trim();
  return <span className={cls}>{children}</span>;
};

export default Chip;
